import React from "react"
import Wrapper from "@components/Wrapper"
import styles from "./Highlights.module.scss"
import selfServicePassword from "./self-service-password.png"
import automatedAccountProvisioning from "./automated-account-provisioning.png"
import permissionManagement from "./permission-management.png"
import singleSignOn from "./single-sign-on.png"

const Card = props => {
  return (
    <div className={props.className}>
      <img className="mb-5" src={props.imgSrc} alt={props.imgAlt}></img>
      {props.children}
    </div>
  )
}

const CardContent = props => {
  return (
    <p className="proxima-nova--semi-bold fs-18pt mx-auto mb-8">
      <span className="d-inline-block">{props.line1}</span>{" "}
      <span className="d-inline-block">{props.line2}</span>
    </p>
  )
}

const Highlights = props => {
  return (
    <section className="container-fluid bg-xl-light-gray">
      <div className="row ml-0 mr-0">
        <Wrapper className={"w-100 text-center"} gap="outer">
          <div className="row bg-white">
            <h3
                className={ styles.topHeader + 
                  " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt mx-auto pb-10"
                }
              >
              Radically Changing the Way Small and Medium
              Companies Securely Access Their Apps — in the Cloud
              and Behind the Firewall
             </h3>
          </div>
          <div className="row bg-white pb-10">
            <div>
              <p className={ styles.topDescription }>
                Maintaining security while giving staff friction-free access to software is a massive challenge for IT departments.
              </p>
              <p className={ styles.topDescription }>
                Setting employees up with individual access to all the software they need burns time and resources. And when staff 
                have to memorize separate logins for multiple apps, there’s inevitable costly pressure on help desks.
              </p>
              <p className={ styles.topDescription }>
                That’s why we’ve created a comprehensive identity and access management solution for small and medium companies. 
                You have total control over who has access to which applications — inside the firewall or in the cloud. It’s more 
                secure than maintaining individual logins for every system but exponentially faster to set up and lock down.
              </p>
            </div>            
          </div>
          <div className="row bg-white">
            <h3
                className={
                  " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt mx-auto pb-10"
                }
              >
              FEATURE HIGHLIGHTS
             </h3>
          </div>
          <div className="row bg-white">
            
            {/* <Card
              className="col-12 col-lg-4 col-xl-4"
              imgSrc={selfServicePassword}
              imgAlt="identity card thumbs up"
            >
              <CardContent
                line1="Self Service Password"
                line2="Management and synchronization"
              />
            </Card> */}
            <Card
              className="col-12 col-lg-3 col-xl-3"
              imgSrc={automatedAccountProvisioning}
              imgAlt="various applications from the cloud accessible via EngineID"
            >
              <CardContent
                line1="Log in to all your applications"
                line2="with a single, secure login."
              />
            </Card>
            <Card
              className="col-12 col-lg-3 col-xl-3"
              imgSrc={singleSignOn}
              imgAlt="identity card thumbs up"
            >
              <CardContent
                line1="Manage access to applications based on"
                line2="job roles or user groups."
              />
            </Card>
            <Card
              className="col-12 col-lg-3 col-xl-3"
              imgSrc={permissionManagement}
              imgAlt="mobile and desktop showing approval and permission management"
            >
              <CardContent
                line1="Passwordless and Multi-Factor Authentication"
                line2="options for secure login."
              />
            </Card>
            <Card
              className="col-12 col-lg-3 col-xl-3"
              imgSrc={selfServicePassword}
              imgAlt="mobile and desktop showing approval and permission management"
            >
              <CardContent
                line1="Let your staff request the access they need "
                line2="with approval workflow."
              />
            </Card>
            {/* <Card
              className="col-12 col-lg-4 col-xl-4"
              imgSrc={automatedAccountProvisioning}
              imgAlt="various applications from the cloud provisioned by EngineID"
            >
              <CardContent
                line1="Automated Account Provisioning to"
                line2="cloud & on-premise applications"
              />
            </Card> */}
            {/* <Card
              className="col-12 col-lg-4 col-xl-4"
              imgSrc={permissionManagement}
              imgAlt="mobile and desktop showing approval and permission management"
            >
              <CardContent
                line1="Self Service Permission Management"
                line2="with Approval Workflow"
              />
            </Card>
            <Card
              className="col-12 col-lg-4 col-xl-4"
              imgSrc={singleSignOn}
              imgAlt="scanned fingerprint"
            >
              <CardContent
                line1="Single Sign-on to corporate"
                line2="applications"
              />
            </Card> */}
          </div>
        </Wrapper>
      </div>
    </section>
  )
}

export default Highlights
